import axios from 'axios'
import router from '../router'
import { Message, MessageBox, Loading } from 'element-ui'
import * as userContext from '@/utils/userContext'

// 创建axios实例
const service = axios.create({
    baseURL:'',
    timeout: 20000, // 请求超时时间
    headers: {
        'content-type': 'application/json;charset=UTF-8'
    }
});

let loadingObj = '';
let token = "";

// request拦截器
service.interceptors.request.use(config => 
{
    if(config.noToken != undefined && config.noToken == true)
    {

    }
    else
    {
        if(token == "" || token ==null)
        {
            token =  userContext.getToken();
        }
    
        if (token != undefined && token!=null && token!="") 
        {
            config.headers['token'] = token;
        }
        else if(!config.noToken) 
        {
            router.push('/login');
        }
    }


      //在发送请求之前做某件事
    if(config.data!="")
    {
        config.data = JSON.stringify(config.data);
    }
    
    if(!config.noLoading)
    { 
        if(!config.loading)
        {
            config.loading = {};
        }

        loadingObj = Loading.service(
        { 
            lock: true,
            text: config.loading.text || '操作正在执行',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
            customClass: 'loadingStyle'
        });
    }
    else
    {
        if(loadingObj)
        {
            loadingObj.close();
        }
    }
    return config;
}, 
error => 
{
    Promise.reject(error)
    
    if(loadingObj)
    {
        loadingObj.close();
    }
})

// response拦截器
service.interceptors.response.use(
    response => {
        
        if(loadingObj)
        { 
            loadingObj.close();
        }
        if (response.data.reason == 7001) {
            router.replace({
                path: '/login', 
            })
            userContext.clearLoginResult();
            location.reload();
        }
        return Promise.resolve(response)
    },
    error => {
        if(loadingObj)
        { 
            loadingObj.close();
        }

        let msg =  "错误信息："+ error.message+"<br/>";
        if(error.config && error.config.url){
             msg += "请求地址："+ error.config.url;
        }

        MessageBox.alert(msg, '出现错误', 
        {
            dangerouslyUseHTMLString: true
        })
    }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/fetch.js